import { render } from "./UserListSort.vue?vue&type=template&id=70935b01&ts=true"
import script from "./UserListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user/components/UserListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70935b01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70935b01', __exports__)) {
    api.reload('70935b01', __exports__)
  }
  
  module.hot.accept("./UserListSort.vue?vue&type=template&id=70935b01&ts=true", () => {
    api.rerender('70935b01', render)
  })

}


export default __exports__